/**
 * Iter-178 · Phase 3 — Resident vs Tenant terminology helper.
 *
 * Surface-only: the DB role stays `tenant` for everyone. This helper
 * picks the correct user-facing label based on the property type the
 * user is registered under.
 *
 *   - Multifamily / Residential / Condo / Apartment  → "Resident"
 *   - Everything else in the NECS commercial catalog → "Tenant"
 */
const RESIDENT_PROPERTY_TYPES = new Set([
  'multifamily', 'multi_family', 'multi-family',
  'residential', 'residential_building',
  'condo', 'condominium',
  'apartment', 'apartments',
]);

export function isResidentPropertyType(propertyType) {
  if (!propertyType) return true; // safe default — multifamily is the anchor product
  return RESIDENT_PROPERTY_TYPES.has(String(propertyType).toLowerCase().trim());
}

/** Return "Resident" or "Tenant" for the property context provided. */
export function roleTermFor(propertyType) {
  return isResidentPropertyType(propertyType) ? 'Resident' : 'Tenant';
}

export function isAuthorizedUser(user) {
  return Boolean(user?.is_authorizer || user?.account_holder_id || user?.account_type === 'A/U');
}

export function accountLabelFor(user, propertyType) {
  return `${roleTermFor(propertyType || user?.property_type)} ${isAuthorizedUser(user) ? 'A/U' : 'A/H'}`;
}

/** Pluralized version. */
export function roleTermPluralFor(propertyType) {
  return roleTermFor(propertyType) + 's';
}

/** Return the account-holder's label including possessive form.
 *  Example: roleTermPossessive({property_type: 'office'}) === "Tenant's"
 */
export function roleTermPossessiveFor(propertyType) {
  return roleTermFor(propertyType) + "'s";
}
